/**
 * Locale API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { detectLocale } from "../generated/locale/locale";

import { wrapMethod } from "./utils";

export const locale = {
  /** @see detectLocale */
  detectLocale: wrapMethod(detectLocale),
} as const;

export type LocaleApi = typeof locale;
